import _ from 'lodash';

import {
  defaultAddressValues,
  sexOptions as sexOptionsArray,
} from 'common-src/models/Patient/constants';

export const initialState = {
  firstName: '',
  lastName: '',
  dob: null,
  sex: null,
  email: '',
  phoneNumber: '',
  address: defaultAddressValues,
  initialFlow: null,
};

export const sexOptions = _.map(sexOptionsArray, (option) => ({ value: option, label: option }));
